import { createTheme, ThemeProvider as MaterialThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { AppGlobalStyles } from '@/components/global-styles';
import palette from './palette';
import shadows from './shadows';
import shape from './shape';
import spacing from './spacing';
import type { ThemeProviderProps } from './types';
import typeset from './typeset';

export const amsTheme = createTheme({
  palette,
  shadows,
  shape,
  typography: typeset,
  customSpacing: spacing,
});

export const ThemeProvider = ({ theme = amsTheme, children }: ThemeProviderProps) => {
  return (
    <StyledEngineProvider injectFirst>
      <MaterialThemeProvider theme={theme}>
        <AppGlobalStyles />
        {children}
      </MaterialThemeProvider>
    </StyledEngineProvider>
  );
};
